export function useMarqueeAnimation(marquee, wrapper) {
    const { $gsap: gsap, $ScrollTrigger: ScrollTrigger } = useNuxtApp();
    const speed = 4;
    const scrollSpeed = 8;
    const marqueeWrpWidth = wrapper.scrollWidth;
    const marqueeSpeed = speed * (marqueeWrpWidth / window.innerWidth);

    const marqueeLine = gsap.to(wrapper, {
        xPercent: -100,
        repeat: -1,
        duration: marqueeSpeed,
        ease: "linear",
        paused: true
    }).totalProgress(0.5);


    gsap.set(wrapper, {
        xPercent: 50
    });

    let marqueeDirection = 1;

    ScrollTrigger.create({
        trigger: marquee,
        start: "top bottom",
        end: "bottom top",
        onUpdate(self) {
            if (self.direction !== marqueeDirection) {
                marqueeDirection *= -1;
                if (marquee.getAttribute('data-marquee-direction') == 'right') {
                    gsap.to(marqueeLine, {
                        timeScale: (marqueeDirection * -1),
                        overwrite: true
                    });
                } else {
                    gsap.to(marqueeLine, {
                        timeScale: marqueeDirection,
                        overwrite: true
                    });
                }
            }
            self.direction === -1 ?
                marquee.setAttribute('data-marquee-status', 'normal') :
                marquee.setAttribute('data-marquee-status', 'inverted');
        },
        onEnter: () => marqueeLine.play(),
        onEnterBack: () => marqueeLine.play(),
        onLeave: () => marqueeLine.pause(),
        onLeaveBack: () => marqueeLine.pause()
    });


    const marqueeTl = gsap.timeline({
        scrollTrigger: {
            trigger: marquee,
            start: "0% 100%",
            end: "100% 0%",
            scrub: 0
        }
    });

    if (marquee.getAttribute('data-marquee-direction') == 'left')
        marqueeTl.fromTo(wrapper, {
            x: scrollSpeed + "vw",
        }, {
            x: scrollSpeed * -1 + "vw",
            ease: "none"
        });

    if (marquee.getAttribute('data-marquee-direction') == 'right')
        marqueeTl.fromTo(wrapper, {
            x: scrollSpeed * -1 + "vw",
        }, {
            x: scrollSpeed + "vw",
            ease: "none"
        });
}